import { render, staticRenderFns } from "./PasswordChangeRequestCmp.vue?vue&type=template&id=44d0a0d1"
import script from "./PasswordChangeRequestCmp.vue?vue&type=script&lang=js"
export * from "./PasswordChangeRequestCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports